import {
  canStartInterveneSession,
  isInterveneSessionActive,
} from './sessionToggleRules';
import { getLastActiveFromUser, isSessionExpired } from './sessionWindow';

/** @typedef {'active' | 'idle' | 'expired'} ComposerMode */

/**
 * Composer UX modes:
 * - active  → free-form messaging (agent is intervening)
 * - idle    → WhatsApp window open; agent must click Start
 * - expired → 24h window closed / History; template only
 *
 * @param {string | undefined} userType
 * @param {object | null | undefined} user
 * @returns {ComposerMode}
 */
export function getComposerMode(userType, user) {
  if (userType === 'history') return 'expired';

  const lastActive = getLastActiveFromUser(user);
  if (isInterveneSessionActive(user)) return 'active';

  if (lastActive && isSessionExpired(lastActive)) return 'expired';

  // Window still open (or unknown) but agent has not started intervene yet.
  if (canStartInterveneSession(userType, user)) return 'idle';

  return 'active';
}

export function isComposerExpired(mode) {
  return mode === 'expired';
}

export function isComposerIdle(mode) {
  return mode === 'idle';
}

export function isComposerActive(mode) {
  return mode === 'active';
}

export function canComposeFreeForm(mode) {
  return mode === 'active';
}
